import {
  getOnboardingRuntimeConfig,
  type OnboardingRuntimeConfig,
} from './onboarding-presenter';

export type { OnboardingRuntimeConfig };

export function buildAvatarPanelMarkup(): string {
  return `
    <aside class="onboarding-avatar-panel" id="onboarding-avatar-panel" aria-label="Сценарное сопровождение">
      <div class="onboarding-avatar-stage" id="onboarding-avatar-stage">
        <video id="onboarding-avatar-video" class="onboarding-avatar-video" playsinline hidden></video>
        <p class="onboarding-avatar-replica" id="onboarding-avatar-replica" aria-live="polite"></p>
      </div>
      <details class="onboarding-avatar-clarify" id="onboarding-avatar-clarify">
        <summary>Задать уточняющий вопрос</summary>
        <form id="onboarding-clarify-form" class="onboarding-clarify-form">
          <label class="onboarding-field-label" for="onboarding-clarify-input">Короткий вопрос по термину или шагу</label>
          <input
            type="text"
            id="onboarding-clarify-input"
            class="onboarding-clarify-input"
            maxlength="500"
            placeholder="Например: что такое реакция?"
            autocomplete="off"
          />
          <p class="onboarding-clarify-hint" id="onboarding-clarify-hint"></p>
          <button type="submit" class="onboarding-btn onboarding-btn-secondary" id="onboarding-clarify-submit">
            Спросить
          </button>
        </form>
        <div class="onboarding-clarify-answer" id="onboarding-clarify-answer" hidden></div>
      </details>
    </aside>
  `;
}

export function setAvatarReplicaText(text: string) {
  const el = document.getElementById('onboarding-avatar-replica');
  if (el) el.textContent = text;
}

export function setAvatarVideoSrc(url?: string) {
  const video = document.getElementById('onboarding-avatar-video') as HTMLVideoElement | null;
  if (!video) return;
  if (!url) {
    video.hidden = true;
    video.removeAttribute('src');
    return;
  }
  video.hidden = false;
  video.src = url;
  void video.play().catch(() => {
    // autoplay may be blocked
  });
}

export function updateClarifyHint(used: number, max: number) {
  const hint = document.getElementById('onboarding-clarify-hint');
  if (!hint) return;
  const remaining = Math.max(0, max - used);
  hint.textContent =
    remaining > 0
      ? `Осталось уточнений: ${remaining} из ${max}`
      : 'Лимит уточнений исчерпан — продолжайте запись.';
}

export function showClarifyAnswer(text: string) {
  const box = document.getElementById('onboarding-clarify-answer');
  if (!box) return;
  box.hidden = false;
  box.textContent = text;
}

export function findReplicaForScreen(
  screen: string,
  stepKey?: string
): { id: string; text: string } | null {
  const script = getOnboardingRuntimeConfig().avatar?.script?.replicas;
  if (!script) return null;

  const match = script.find((r) => {
    if (r.screen !== screen) return false;
    if (screen === 'wizard' && stepKey) return r.step_key === stepKey && r.trigger === 'step_enter';
    return r.trigger === 'screen_enter';
  });

  return match ? { id: match.id, text: match.text } : null;
}
